import { render, staticRenderFns } from "./eliminar_departamentos_prolipa.vue?vue&type=template&id=649972f4"
import script from "./eliminar_departamentos_prolipa.vue?vue&type=script&lang=js"
export * from "./eliminar_departamentos_prolipa.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports